'use client';

import React from 'react'

import IInfo from "@public/svg/i-info";

const TextInput = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  required = false,
  className = "",
  wrapperClassName = "mb-4",
  errorClassName = "text-[#ED263D] text-[11px]/[15.4px] font-satoshi tracking-[0.11px] mt-1 flex items-center gap-0.5 rounded-[2px] bg-[#FDE9EC] p-1"
}) => {
  return (
    <div className={wrapperClassName}>
      {label && (
        <label htmlFor={name} className="ml-[12px] block text-gray-700 mb-1">
          {label}

          {required && <span className='text-[#FA2D1E] text-13 font-sfpro-semibold'>*</span>}
        </label>
      )}
      <input
        id={name}
        className={`text-17 border-[1px] border-solid rounded-[8px] py-[10px] px-[12px] w-full border-[#DEDFDE] focus:ring-[#040704] focus:outline-none focus:ring-[1px]  ${className}`}
        type="text"
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
      />
      {error && <p className={`${errorClassName}`}><IInfo color='#ED263D' width={16} height={16} /> {error}</p>}
    </div>
  );
};

export default TextInput;

